window.addEventListener('load', async function() {
  const autoplayingContainers = document.querySelectorAll('.video_autoplaying_container');
  await Promise.all(Array.from(autoplayingContainers).map(processContainer));

  const observer = new MutationObserver(() => {
    const containers = document.querySelectorAll('.video_autoplaying_container');
    containers.forEach(processContainer);
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

async function processContainer(container) {
  if (!container) return;

  const unmuteBtnMobile = container.querySelector('.btn-mute-audible.mobile');
  const unmuteBtnDesktop = container.querySelector('.btn-mute-audible.desktop');
  const visibleBtn = unmuteBtnMobile || unmuteBtnDesktop;
  if (!visibleBtn) return;

  if (document.body.contains(unmuteBtnMobile)) {
    console.log('Mobile mute button found');
  }
  if (document.body.contains(unmuteBtnDesktop)) {
    console.log('Desktop mute button found');
  }

  const renderedVideo = container.querySelector('video');
  if (!renderedVideo) return;

  // Only add listener once
  if (!visibleBtn.hasAttribute('data-mute-setup')) {
    visibleBtn.setAttribute('data-mute-setup', 'true');
    visibleBtn.addEventListener('pointerup', function() {
      const video = container.querySelector('video');
      const audibleIcon = visibleBtn.querySelector('.svg-wrapper.audible');
      const muteIcon = visibleBtn.querySelector('.svg-wrapper.mute');
      if (video) {
        if (video.muted) {
          video.muted = false;
          if (audibleIcon) audibleIcon.classList.remove('hidden');
          if (muteIcon) muteIcon.classList.add('hidden');
        } else {
          video.muted = true;
          if (audibleIcon) audibleIcon.classList.add('hidden');
          if (muteIcon) muteIcon.classList.remove('hidden');
        }
      }
    });
  }

  visibleBtn.classList.remove('hide-while-loading');
}
